import { ReactNode } from 'react'

// Components
import { Layout } from '@tracklib/kit'
import BodyClassName from 'components/base/bodyclassname'

import styles from './checkoutlayout.css'

type CheckoutLayoutProps = {
  children: ReactNode
  sidebarContent?: JSX.Element
  footer?: boolean
}

const CheckoutLayout = (props: CheckoutLayoutProps): JSX.Element => {
  const { children, sidebarContent, footer = true } = props
  return (
    <Layout.SideBar
      sidebarContent={sidebarContent}
      sideBarClassName={styles.sidebar}
      sideBarWrapperClassName={styles.sidebarWrapper}
      className={styles.background}
      maxWidth={1024}
      sticky={false}
      side="left"
    >
      <BodyClassName className={styles.bg} />
      <div className={styles.wrapper}>{children}</div>
      {footer && <p className={styles.copyright}>{`© ${new Date().getFullYear()} Tracklib - All rights reserved`}</p>}
    </Layout.SideBar>
  )
}

export default CheckoutLayout
